import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import Image from "../../../../img/OrgAgent.png";
import Links from "../../../Links";

const Section = styled(ProjectSection)`
  background: #1574c6;
`;

const Link = styled(Links)`
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 1);
  &:hover,
  &:focus {
    color: white;
    border-bottom: none;
  }
  &:focus {
    outline-color: white;
  }
`;

const Button = styled(Links)`
  display: block;
  background-color: rgba(0, 0, 0, 0.05);
  display: inline-block;
  text-align: center;
  color: white;
  height: auto;
  text-decoration: none;
  padding: 0px 1.5em;
  border-radius: 3.125em;
  line-height: 3;
  box-shadow: 0 1px 1px 0px rgba(0, 0, 0, 0.5), 0 -1px 0 0 rgba(255, 255, 255, 0.1);
  border-bottom: none;
  font-size: var(--font-size-text-small);
  &:hover,
  &:active {
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
  }
  &:visited {
    color: white;
  }
  &:focus {
    outline-color: white;
  }
`;

const ButtonGroup = styled.div`
  display: grid;
  grid-template-columns: auto;
  justify-content: center;
  gap: var(--spacing-small);
  margin-bottom: var(--spacing-large);

  @media (min-width: 500px) {
    grid-template-columns: auto;
  }
`;

const LocalProjectDescription = styled.p`
  margin-bottom: var(--spacing-medium);
  font-size: var(--font-size-text-small);

  @media (min-width: 768px) {
    padding: var(--spacing-clear) var(--spacing-medium);
  }
`;

function OrgAgent() {
  return (
    <Section>
      <ProjectTitle title="Org Agent Hub" tag="2025" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
        <Badge small title="Agents & AI">
          <Icons type="ai-small" />
        </Badge>
        <Badge tooltip="large" small title="Web Components">
          <Icons type="web-components-small" />
        </Badge>
      </ProjectSectionSkills>
      <LocalProjectDescription>
        The Org Agent Hub is a hypothetical concept inspired by my{" "}
        <Link href="/case-studies#orgagent">Role-Aware Org Agents</Link> article. It envisions a future home where
        employees can access a central model, switch between role-specific agents or AI Personas, and connect to
        relevant tools, turning organisational knowledge into actionable, tailored support.
      </LocalProjectDescription>

      <ProjectDescription>
        I prototyped this vision using my Muibook Design System to demonstrate how an Org Agent interface could make
        organisational knowledge more accessible and actionable
      </ProjectDescription>

      <ButtonGroup>
        <Button href="/case-studies#orgagent" color="white">
          Learn more
        </Button>
      </ButtonGroup>

      <ProjectHeroImage src={Image} desktop />
    </Section>
  );
}

export default OrgAgent;
